const asString = (value: unknown): string => (
	typeof value === 'string' ? value : ''
);


const isString = (value: unknown): value is string => typeof value === 'string';


const isNumber = (value: unknown): value is number => typeof value === 'number';


const isBoolean = (value: unknown): value is boolean => typeof value === 'boolean';


const isRecord = (value: unknown): value is Record<string, unknown> => (
	typeof value === 'object' && value !== null
);


const isStringArray = (value: unknown): value is string[] => (
	Array.isArray(value) && value.every(isString)
);


const isNullableString = (value: unknown): value is string | null => (
	value === null || isString(value)
);


const isNullableNumber = (value: unknown): value is number | null => (
	value === null || isNumber(value)
);


const isOneOf = <T extends string>(
	value: unknown,
	allowed: readonly T[],
): value is T => isString(value) && allowed.some(item => item === value);


export {
	asString,
	isBoolean,
	isNullableNumber,
	isNullableString,
	isNumber,
	isOneOf,
	isRecord,
	isString,
	isStringArray,
};
